import * as __SNOWPACK_ENV__ from '../_snowpack/env.js';
import.meta.env = __SNOWPACK_ENV__;

import App from "./App.svelte.js";
import init from "./diamond-wasm/index.js";
(async () => {
  await init();
  var app = new App({
    target: document.body
  });
  if (undefined /* [snowpack] import.meta.hot */ ) {
    undefined /* [snowpack] import.meta.hot */ .accept();
    undefined /* [snowpack] import.meta.hot */ .dispose(() => {
      app.$destroy();
    });
  }
})();
